import * as React from 'react';
import { SVGProps } from 'react';

const IconSpeedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 7.244c-5.034 0-9 4.07-9 8.94C5 18.323 6.224 20.452 7.5 22L5 24c-1.729-2.098-3-4.824-3-7.816C2 9.286 7.536 4 14 4s12 5.286 12 12.184c0 2.992-1.271 5.718-3 7.816l-2.5-2c1.276-1.548 2.5-3.677 2.5-5.816 0-4.87-3.966-8.94-9-8.94Z" />
    <path d="M15.5 18a2 2 0 0 1-3.464-2c.748-1.295 5.73-5.924 5.73-5.924S16.247 16.706 15.5 18Z" />
  </svg>
);
export default IconSpeedSizeL;
